export default __webpack_public_path__ + "atomic/_patterns/03-organisms/paragraph-call-to-action/_paragraph-call-to-action.twig";